<header class="content-contained">
    <h1>£29.99 Online Planning Service</h1>
    <div class="panel">
        <p>
            We know that not everyone is comfortable using our free online kitchen planner, therefore, our £29.99 Online Planning Service is there to lend a hand and help you get started on your DIY Kitchens journey.
        </p>
    </div>
</header>

<hr class="narrow" />

<section class="content-contained">
    <div class="video">
        <div class="video-thumbnail" (click)="playPlanningServiceVideo()" #planningServiceExplainedThumbnail>
            <img src="https://static.diy-kitchens.com/assets/images/planning-service/online-planning-1200-1.jpg" width="100%"/>
        </div>
        <video controls="" class="video-planning-service hidden" #planningServiceExplained>
            <source src="https://static.diy-kitchens.com/assets/images/planning-service/online-planning-service-explained.mp4" />
        </video>
    </div>
</section>

<section class="content-contained">
    <div class="panel">
        <div class="panel-left">
            <h3>What is the £29.99 Online Planning Service?</h3>
            <p>
                The Online Planning Service is there to give you a helping hand, providing you with a 
                comprehensive kitchen plan. Whether you are a complete novice and not sure where to 
                start, or if you’ve had a go at planning your own kitchen and just want an alternative 
                design, our team of online planners are here to help!
            </p>
            <p>
                You may be asking why we’re charging £29.99 for this service when other suppliers 
                provide a free design service. The answer is transparency.  We want all our customers 
                to benefit from our low unit prices, therefore, if you don’t need help then you don’t 
                pay extra for design services, which, even if advertised as being free, the cost is normally 
                included with higher unit prices. However, if you do need a helping hand, then £29.99 is a 
                relatively low price to pay for a complete kitchen design.
            </p>
        </div>
        <div class="panel-right">
            <component-product-image-gallery [images]="[{image: 'https://static.diy-kitchens.com/assets/images/planning-service/online-planning-1200-1.jpg', alt: 'Planning Mode Selection Image'}]"></component-product-image-gallery>
        </div>
    </div>
</section>

<section class="content-contained">
    <div class="panel">
        <div class="panel-left">
            <h3>How does it work?</h3>
            <p>
                It’s simple. All you need to do is measure your kitchen and create the room shape in our planner. 
                Based on this, the planner will automatically show where you could include kitchen units, and you 
                will be able to adjust this accordingly by using the toggles and sliders.
            </p>
            <p>
                Next, you complete a survey about the door style, colour, appliances and other features that you 
                want to include. Once you’ve checked out, our design team will take over and aim to create a 
                kitchen plan based on your requirements, within 48 hours.
            </p>
            <p>
                Once you’ve received your plan, you can request an additional amend for free (this could be a 
                minor amend all the away up to a completely new design) and you can then either place your order, 
                make your own amends for free or alternatively request additional amends through our design team 
                (please note that additional amends are charged at £14.99 inc Vat per amend).
            </p>
        </div>
        <div class="panel-right">
            <component-product-image-gallery [images]="[{image: 'https://static.diy-kitchens.com/assets/images/planning-service/online-planning-1200-2.jpg', alt: 'Planning Service Example'}]"></component-product-image-gallery>
        </div>
    </div>
</section>
<section class="content-contained">
    <div class="button-wrapper">
        <a href="https://planner.diy-kitchens.com/plan/mode" title="Launch Online Planning Service" target="_blank">
            <button mat-flat-button color="primary" title="Launch Online Planning Service">Launch the £29.99 Online Planning Service</button>
        </a>
        <p>
            Please note that the online planner is only compatible with PC, Mac and selected tablets. Mobile devices are not supported.
        </p>
    </div>
</section>
